import React from 'react';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Info } from 'lucide-react';

const StaffNotesSection = ({ formData, onChange }) => (
  <Card className="rounded-2xl border-[#E0D6C8] bg-[#FAF8F5]">
    <CardHeader className="pb-4">
      <div className="flex items-center gap-2">
        <CardTitle className="text-lg font-['Manrope']">Staff Notes</CardTitle>
        <div className="flex items-center text-xs text-[#888888] bg-[#F3EFE9] px-2 py-1 rounded-full">
          <Info className="w-3 h-3 mr-1" /> Not shown to clients
        </div>
      </div>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label>How to Access</Label>
        <Textarea data-testid="how-to-access-input" placeholder="Internal notes on how to connect clients..." value={formData.how_to_access} onChange={(e) => onChange('how_to_access', e.target.value)} className="rounded-xl mt-1.5" />
      </div>
      <div>
        <Label>Known Barriers</Label>
        <Textarea data-testid="barriers-input" placeholder="Known issues or barriers clients may face..." value={formData.known_barriers} onChange={(e) => onChange('known_barriers', e.target.value)} className="rounded-xl mt-1.5" />
      </div>
      <div>
        <Label>Staff Tips</Label>
        <Textarea data-testid="staff-tips-input" placeholder="Helpful tips for staff when making referrals..." value={formData.staff_tips} onChange={(e) => onChange('staff_tips', e.target.value)} className="rounded-xl mt-1.5" />
      </div>
    </CardContent>
  </Card>
);

export default StaffNotesSection;
